import React from 'react';
import { Box, TextField } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { FieldRow, useDesignTokens } from '../ui';
import { radius } from '../../themes/smartinventoryTheme';

// Preset swatch row (the six seeded category hues) in front of a free hex
// input — admins can still pick any colour, per CHANGES.md §2.8.
const CategoryFormDrawer = ({ t, form, setForm, formErrors, saving }) => {
  const { categoryColors } = useDesignTokens();
  const presets = Object.values(categoryColors)
    .filter((tone) => tone.dot !== categoryColors.none.dot)
    .map((tone) => tone.dot);

  return (
    <>
      <FieldRow label={t('Category Name')} error={formErrors.categoryName} required>
        <TextField
          fullWidth
          value={form.categoryName}
          onChange={(e) => setForm({ ...form, categoryName: e.target.value })}
          disabled={saving}
          error={Boolean(formErrors.categoryName)}
        />
      </FieldRow>

      <FieldRow label={t('Category Color:')}>
        <Box sx={{ display: 'flex', gap: 1, mb: 1.5, flexWrap: 'wrap' }}>
          {presets.map((hex) => {
            const selected = form.categoryColor?.toLowerCase() === hex.toLowerCase();
            return (
              <Box
                key={hex}
                onClick={() => !saving && setForm({ ...form, categoryColor: hex })}
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: `${radius.sm}px`,
                  bgcolor: hex,
                  cursor: saving ? 'default' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '2px solid',
                  borderColor: selected ? 'text.primary' : 'transparent',
                }}
              >
                {selected && <CheckIcon fontSize="small" sx={{ color: 'common.white' }} />}
              </Box>
            );
          })}
        </Box>
        <TextField
          fullWidth
          value={form.categoryColor}
          onChange={(e) => setForm({ ...form, categoryColor: e.target.value })}
          disabled={saving}
          placeholder="#3f51b5"
          InputProps={{
            startAdornment: (
              <Box sx={{ width: 18, height: 18, borderRadius: '50%', bgcolor: form.categoryColor, mr: 1, flexShrink: 0, border: '1px solid', borderColor: 'divider' }} />
            ),
          }}
        />
      </FieldRow>
    </>
  );
};

export default CategoryFormDrawer;
